import { IconX } from "@decibeltrade/react-icons";
import { IconButton } from "@decibeltrade/web-core/components";
import { useTranslations } from "next-intl";
import { css, cx } from "styled-system/css";

export interface ModalCloseButtonProps {
  close: () => void;
  className?: string;
}

export const ModalCloseButton = ({ close, className }: ModalCloseButtonProps) => {
  const t = useTranslations("general");
  return (
    <div className={cx(css({ position: "absolute", top: "24", right: "24" }), className)}>
      <IconButton
        size="lg"
        variant="text"
        onClick={close}
        ariaLabel={t("close")}
        className={css({ my: "-12", mx: "-20" })}
      >
        <IconX />
      </IconButton>
    </div>
  );
};
